import * as React from 'react'
import classNames from '../../_util/classNames'

interface TargetProps {
  className?: string
  address?: string
}

const ContainerCoin: React.FC<TargetProps> = (props: TargetProps) => {
  const { className, address = '' } = props

  const classes = classNames(className)

  // 处理图片加载错误
  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.src = '/images/_global/icon-coin_default.svg'
  }

  return <img className={classes} src={address} alt="icon" onError={handleImageError} />
}

export default React.memo(ContainerCoin)
